/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PlayerGuardedRoute = ({
  component: Component,
  auth,
  userRole,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!auth) {
          return <Redirect to="/player-login" />;
        }
        if (userRole && userRole !== 'player') {
          return <Redirect to="/messages" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PlayerGuardedRoute;
